<template>

    <div :class="'a-productGrid__item mb-2' + [item.herny_produkt_kategoria !== 'background' ? ' --small' : ' --medium'] + [!item.disabled ? '' : ' --soldout']" :style="'z-index:' + [60 - index]">

        <div v-if="isPozadie" class="productGridItem__imgWrap">
            <img :src="'assets/img/produkty/'+ item.herny_produkt_kategoria +'/'+ item.herny_produkt_img_inventar" class="img-fluid" alt="">
        </div>

        <!-- Produkt info -->
        <div class="productGridItem_content">
            <!-- Img -->
            <div class="productGridItem__imgWrap">
                <img v-if=" !isPozadie " :src="'assets/img/produkty/'+ item.herny_produkt_kategoria +'/'+ item.herny_produkt_img_inventar" alt="" class="img-fluid">
            </div>

            <!-- Názov + Price / Zakúpené -->
            <div class="productGridItem_content">
                <div class="productGridItem__title">{{ item.herny_produkt_meno }}</div>
                <div v-if="!item.disabled" class="productGridItem__price">
                    <span class="icon"></span>{{ item.herny_produkt_cena }}
                </div>
                <div v-else class="productGridItem__alreadyBought">
                    Zakúpené
                </div>
            </div>
        </div>

        <!-- Kúpiť -->
        <div v-if="!item.disabled" class="productGridItem__button">
            <div @click="$emit('buyProduct', index, item)" class="btn">
                <span class="icon"></span>Kúpiť
            </div>
        </div>

        <!-- Novinka -->
        <span v-if="item.herny_produkt_novinka" class="productGridItem__new__tag">Nové</span>
    </div>

</template>



<script>
    export default {
        props: [
            'index',
            'item'
        ],
        mounted() {
        },
        computed: {
            isPozadie: function () {
                return  this.item.herny_produkt_kategoria === 'background'
            }
        }
    }
</script>